import { type Task, TaskStatus } from "@taskfortress/core"
import React from "react"
import { type PropsWithClassname } from "../../types"
import { Draggable } from "../dragDrop"
import { TaskItem } from "./TaskItem"

interface DraggableTaskItemProps extends PropsWithClassname {
  task: Task
  disabled?: boolean
  textClassName?: string
}

export const DraggableTaskItem: React.FC<DraggableTaskItemProps> = ({
  task,
  disabled = false,
  className,
  textClassName,
}) => {
  // Disable dragging for DONE tasks
  const isDragDisabled = disabled || task.status === TaskStatus.DONE

  return (
    <Draggable id={task.id} disabled={isDragDisabled} data={{ task }}>
      <TaskItem
        task={task}
        className={className}
        textClassName={textClassName}
      />
    </Draggable>
  )
}
